import './calendar-content.component.scoped.sass';
import React from 'react';

export const CalendarContentComponent = () => {
    return (
        <div className="calendar-content">
            Calendar view
        </div>
    )
}